





















import CompanyFooter from "./company-footer.vue";

export default {
	components:{
		CompanyFooter
	}
};

